import { FC } from "react";
import { Box } from "@mui/material";
import MenuActions from "./MenuActions";
import MenuHeader from "./MenuHeader";
import MenuNavigation from "./MenuNavigation";
import MenuWrapper from "./MenuWrapper";

interface Props {
	menuIsOpen: boolean;
	closeMenu: () => void;
}

/**
 * AppMenu is the side menu that allows users to navigate main sections of GreenRouter UI app.
 *
 * @param menuIsOpen  the flag that indicates if the menu is open or closed
 * @param closeMenu   the handler used to close the menu
 * @returns           the application side menu
 */
const AppMenu: FC<Props> = ({ menuIsOpen, closeMenu }) => (
	<MenuWrapper variant="permanent" open={menuIsOpen}>
		<MenuHeader menuIsOpen={menuIsOpen} closeMenu={closeMenu} />
		<MenuNavigation menuIsOpen={menuIsOpen} closeMenu={closeMenu} />
		<Box flexGrow={1} />
		<MenuActions menuIsOpen={menuIsOpen} closeMenu={closeMenu} />
	</MenuWrapper>
);
export default AppMenu;
